import { jsx as _jsx } from "react/jsx-runtime";
import { ToggleButton as FluentToggleButton, makeStyles } from "@fluentui/react-components";
import { useCallback, useContext } from "react";
import { ToolContext } from "../hoc/fluentToolWrapper";
import { Tooltip } from "./tooltip";
const useStyles = makeStyles({
    button: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
});
/**
 * Displays a controlled toggle button with icons.
 * The parent supplies the checked state through value; clicks request the opposite value through onChange.
 * If no uncheckedIcon is provided, the same icon is used for both states.
 *
 * @param props The controlled state, change callback, icons, and button presentation.
 * @returns The toggle button.
 */
export const ToggleButton = (props) => {
    ToggleButton.displayName = "ToggleButton";
    const { value, onChange, title, appearance = "subtle", ariaLabel } = props;
    const { size } = useContext(ToolContext);
    const classes = useStyles();
    const toggle = useCallback(() => {
        onChange(!value);
    }, [value, onChange]);
    return (_jsx(Tooltip, { content: title ?? "", positioning: props.titlePositioning, children: _jsx(FluentToggleButton, { className: classes.button, size: size, "aria-label": ariaLabel ?? title, icon: value ? _jsx(props.checkedIcon, {}) : props.uncheckedIcon ? _jsx(props.uncheckedIcon, {}) : _jsx(props.checkedIcon, {}), appearance: appearance, checked: value, disabled: props.disabled, onClick: toggle }) }));
};
//# sourceMappingURL=toggleButton.js.map